// Client-side registration of the two equipment-check widgets (sprint 15 rework). The mechanism - the
// dashboards global, and deferring to DOMContentLoaded because ScriptInit runs before the catalogue has
// published its registry - is checkReminderRegistration.ts's, reused rather than repeated.

import { resolveWidgetRegistrar, type RegistrationOutcome } from "../../Compliance/CheckReminders/checkReminderRegistration";
import {
    EquipmentCheckWidget,
    MyEquipmentChecksWidgetKey,
    ProjectEquipmentChecksWidgetKey,
} from "./equipmentCheckWidget";

export const EquipmentCheckWidgetKeys = [MyEquipmentChecksWidgetKey, ProjectEquipmentChecksWidgetKey] as const;

export function registerEquipmentCheckWidgets(scope: unknown = globalThis): boolean {
    const register = resolveWidgetRegistrar(scope);
    if (!register) return false;

    // A factory per key, each closing over its own key - one shared instance would have two cells draw
    // into one host.
    for (const key of EquipmentCheckWidgetKeys)
        register(key, () => new EquipmentCheckWidget(key));

    return true;
}

export function installEquipmentCheckWidgetRegistration(
    scope: unknown = globalThis,
    doc: Pick<Document, "readyState" | "addEventListener"> | undefined =
        typeof document === "undefined" ? undefined : document,
): RegistrationOutcome {
    if (registerEquipmentCheckWidgets(scope)) return "registered";

    // "Not complete", not "loading": see checkReminderRegistration.ts for why.
    if (doc && doc.readyState !== "complete") {
        doc.addEventListener("DOMContentLoaded", () => { registerEquipmentCheckWidgets(scope); }, { once: true });
        return "deferred";
    }

    return "unavailable";
}
